/* eslint-disable react/button-has-type */
import React from "react"
import Slider from "react-slick"
import propTypes from "prop-types"
import SlideItem from "./SlideItem"

function PrevArrow(props) {
  const { onClick, currentSlide } = props
  return (
    <>
      {currentSlide > 0 ? (
        <button className="slider-button -left" onClick={onClick}>
          {"<"}
        </button>
      ) : null}
    </>
  )
}

function NextArrow(props) {
  const { onClick, currentSlide, slideCount } = props
  return (
    <>
      {currentSlide !== slideCount ? (
        <button className="slider-button -right" onClick={onClick}>
          {">"}
        </button>
      ) : null}
    </>
  )
}

NextArrow.propTypes = {
  onClick: propTypes.func.isRequired,
  slideCount: propTypes.number.isRequired,
  currentSlide: propTypes.number.isRequired,
}

PrevArrow.propTypes = {
  onClick: propTypes.func.isRequired,
  currentSlide: propTypes.number.isRequired,
}

const settings = {
  dots: false,
  infinite: false,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  autoplay: true,
  lazyLoad: true,
  autoplaySpeed: 15000,
  pauseOnHover: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
}

class StudioSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeSlide: 0,
      slides: props.slides,
    }
    this.slider = React.createRef()
  }

  handleBeforeChange = (i, e) => {
    const { slides } = this.state

    if (slides[e].node.frontmatter.video) {
      this.slider.current.slickPause()
    } else {
      this.slider.current.slickPlay()
    }
  }

  handleAfterChange = i => {
    this.setState({ activeSlide: i })
  }

  render() {
    const { activeSlide, slides } = this.state
    return (
      <Slider
        ref={this.slider}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...settings}
        beforeChange={(i, e) => this.handleBeforeChange(i, e)}
        afterChange={i => this.handleAfterChange(i)}
      >
        {slides.map((e, i) => (
          <SlideItem
            key={e.node.id}
            data={e.node}
            index={i}
            activeSlide={activeSlide}
          />
        ))}
      </Slider>
    )
  }
}

StudioSlider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  slides: propTypes.array.isRequired,
}

export default StudioSlider
